<template>
  <div>
    <footer-en v-if="currentLang.value == 'en'"></footer-en>
    <footer-cn v-else></footer-cn>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import FooterEn from './modules/footer_en.vue'
import FooterCn from './modules/footer_cn.vue'

export default {
  components: {
    FooterEn,
    FooterCn
  },

  data() {
    return {

    }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ...mapState([
      'langs'
    ]),
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue